import { useEffect } from 'react';

let dialogOpenCount = 0;
let previousRootAriaHidden: string | null = null;

export default function useDialogAriaHidden(open: boolean, rootId = 'root'): void {
    useEffect(() => {
        const root = document.getElementById(rootId);
        if (!root) {
            return;
        }

        if (open) {
            if (dialogOpenCount === 0) {
                previousRootAriaHidden = root.getAttribute('aria-hidden');
                root.setAttribute('aria-hidden', 'true');
            }
            dialogOpenCount += 1;
        }

        return () => {
            if (!open) {
                return;
            }

            dialogOpenCount -= 1;
            if (dialogOpenCount === 0) {
                if (previousRootAriaHidden === null) {
                    root.removeAttribute('aria-hidden');
                } else {
                    root.setAttribute('aria-hidden', previousRootAriaHidden);
                }
                previousRootAriaHidden = null;
            }
        };
    }, [open, rootId]);
}
